"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVisitTaskPageUpdate = exports.taskForRoute = void 0;
const constants_1 = require("../constants");
const __1 = require("..");
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importDefault(require("react"));
const TaskCompletenessContext_1 = require("../../context/TaskCompletenessContext");
// "Named" capture groups
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Groups_and_Ranges
const TASK_PATH_PATTERN = /\/tasks\/(?<task>[a-z-]+)/;
const taskForRoute = (pathname) => {
    var _a;
    const match = pathname.match(TASK_PATH_PATTERN);
    if (!!((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.task)) {
        const matched = Object.keys(__1.TaskDetails).find((t) => __1.TaskDetails[t].routeName === match.groups.task);
        return matched ? constants_1.Tasks[matched] : null;
    }
    else {
        return null;
    }
};
exports.taskForRoute = taskForRoute;
const useVisitTaskPageUpdate = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const { dispatch } = react_1.default.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    react_1.default.useEffect(() => {
        const matchedTask = (0, exports.taskForRoute)(location.pathname);
        if (matchedTask) {
            dispatch({ type: 'VISIT_TASK_PAGE', payload: { task: matchedTask } });
        }
    }, [location]);
};
exports.useVisitTaskPageUpdate = useVisitTaskPageUpdate;
//# sourceMappingURL=taskVisit.js.map